import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

export default function NotFoundPage() {
  useSeo({
    title: "Page not found | Pizza Excellente",
    description: "Sorry, the page you were looking for could not be found.",
    path: "/404",
  });
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-5 py-32 text-center">
      <div className="max-w-md">
        <div className="eyebrow text-pe-orange">404</div>
        <h1 className="font-serif text-5xl md:text-6xl text-pe-ink mt-4">A slice off the path.</h1>
        <p className="mt-5 text-pe-ink/65">The page you’re looking for doesn’t exist. Let’s get you back to the warm side of the oven.</p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center justify-center mt-10 bg-pe-maroon text-white hover:bg-pe-maroon-deep transition-colors px-8 py-4 text-[12px] tracking-[0.15em] font-medium uppercase"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
